export default {
  default: () => import("/app/src/layouts/default.vue"),
  lp: () => import("/app/src/layouts/lp.vue"),
  simple: () => import("/app/src/layouts/simple.vue")
}